import React, { createContext, useContext } from 'react';

interface WorkflowContextType {
  onAddNodeClick?: (sourceNodeId: string, sourceHandle?: string, anchorType?: 'chatModel' | 'memory' | 'tools' | 'parser' | 'tool' | 'pollSource', anchorPosition?: { x: number; y: number }) => void;
  onOpenChatTest?: (nodeId: string) => void;
}

const WorkflowContext = createContext<WorkflowContextType>({});

export const WorkflowProvider: React.FC<{ children: React.ReactNode; value: WorkflowContextType }> = ({ children, value }) => {
  return <WorkflowContext.Provider value={value}>{children}</WorkflowContext.Provider>;
};

export const useWorkflowContext = () => {
  return useContext(WorkflowContext);
};
